import styled from '@emotion/styled'

const Section = styled.section`
    display: flex;
    align-items: flex-start;
    justify-content: ${props => props.$isMobile ? 'center' : 'flex-start' };
    flex-wrap: wrap;
    gap: 1rem;
`

export { Section }
